import { render, staticRenderFns } from "./business-management.vue?vue&type=template&id=caacc3f8&scoped=true&"
import script from "./business-management.vue?vue&type=script&lang=js&"
export * from "./business-management.vue?vue&type=script&lang=js&"
import style0 from "./business-management.vue?vue&type=style&index=0&id=caacc3f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caacc3f8",
  null
  
)

export default component.exports